import type { FaireProductEntity } from "../../entity_types/product";

export const p_82ehrztk7u: FaireProductEntity = {
  token: "p_82ehrztk7u",
  type: "product",
  name: "Spring Green Ponytail Hair Extensions",
  brandToken: "b_cxpu3vwkk5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/569ac1eea2e81acc0f2231635ab18c1e50404353ac4d365882d120acdc136672.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c5a8a23406ac51479bc187e2c7d50d70dc154d75d8b3d2c9a3c11a210b84574.jpeg",
    "https://cdn.faire.com/fastly/a4f54dc97134c9bb2d07a3f1bb87b70aea6165c1143168535964098e06a4ff12.jpeg",
    "https://cdn.faire.com/fastly/8c97992a894fd1ad615e5a059fdb5120d86dc560820344eb305c645d42d7045f.png",
    "https://cdn.faire.com/fastly/fc5a011b9eb228fc73c91edb8db03569e6e8e0740fdf21a7a40b8a8c10b1a368.jpeg",
    "https://cdn.faire.com/fastly/f7125fd06707e056751a5a53b0e0e5186a64bbc727080b25168b67dd850c1f06.jpeg",
    "https://cdn.faire.com/fastly/4bbf897f3d6d639c37a818cb75d060fa3d84c73d33a0058fa5b763af762ee830.jpeg",
    "https://cdn.faire.com/fastly/1cc91497706811ff841715f99188342ac5012937abd7ec5538d3798c861abf57.jpeg",
    "https://cdn.faire.com/fastly/bdd94c6621c5b17a6dc6429519f1e5b5743309d533c45778fd7996b03a044086.jpeg",
    "https://cdn.faire.com/fastly/e08e8981fa90da50db164b3c468dbd33b0c7d01f9b72fd5d88aee309af4d269c.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Green Unicorn Hair You Wear!\n\nMagic Tails are candy-colored, unicorn inspired flip-in ponytail hair extensions. Simply tie your Magic Tail over your own ponytail for a black to vivid green ombre look that will turn heads every where you trot!\n💚 Comfortable to wear all day 💚 High quality hair is soft and silky 💚 Heat resistant up to 275°F \nEasy to Wear All Day!\n\nUse the comb to tuck into your own ponytail and then tie the ribbon underneath. Magic Tails are available in curly and straight textures.\n\nSize: 18/" long\nMaterial: Silky synthetic hair\nColor: Black to Vivid Green\nTexture: Curly\n\n\n',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:52.600Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
